/* Banky Nieuw WP3.2 (Keuzebord #35 collectie-filterbalk, #36 collectie-filters-mobiel): alleen wat het thema niet al doet.
   Filteren, sorteren, verversen van het raster (section rendering), de lade en de focusval blijven van Halo
   (facet-form, facet-sort-by, facet-drawer). Dit script voegt toe:
   1. uitklapfilters in de balk: één tegelijk open, sluiten bij klikken buiten of Escape, paneel binnen het scherm;
   2. de balk volgt de kop: verdwijnt de zwevende kop bij omlaag scrollen, dan schuift de vastgezette balk mee omhoog;
   3. de sheet: live aantal in "Toon ..." (vertraagd opgehaald met dezelfde URL als Halo's formulier), "Wis filters"
      en omlaag vegen aan de grijpstreep om te sluiten;
   4. na verversen komt de focus terug op het filter waarmee je werkte;
   5. sorteren op de telefoon en tablet (de sorteerlijst staat dan buiten facet-sort-by, zie onderaan).
   Werkt opnieuw na elke verversing: <banky-facets> is een eigen element dat zichzelf bij invoegen opzet. */
(() => {
  if (window.customElements.get('banky-facets')) return;
  const stil = window.matchMedia('(prefers-reduced-motion: reduce)');
  let focusNa = null; // {name, value} van het laatst gewijzigde filter

  const bouwUrl = form => {
    const params = new URLSearchParams(new FormData(form));
    const url = new URL(form.action, location.href);
    url.search = '';
    params.forEach((v, k) => url.searchParams.append(k, v));
    ['page', 'filter.v.price.gte', 'filter.v.price.lte'].forEach(k => { if (url.searchParams.get(k) === '') url.searchParams.delete(k); });
    url.searchParams.set('section_id', form.getAttribute('section-id'));
    return url;
  };

  class BankyFacets extends HTMLElement {
    connectedCallback() {
      if (this._ac) return;
      this._ac = new AbortController();
      const sig = {signal: this._ac.signal};
      this.balk = this.querySelector('[data-banky-balk]');
      this.anker = this.querySelector('[data-banky-anker]');

      // 1. Uitklapfilters
      this.drops = [...this.querySelectorAll('details.banky-facets__drop')];
      this.drops.forEach(d => d.addEventListener('toggle', () => {
        if (!d.open) return;
        this.drops.forEach(x => { if (x !== d) x.open = false; });
        this._plaats(d);
      }, sig));
      document.addEventListener('click', e => { if (!e.target.closest?.('.banky-facets__drop')) this._sluitDrops(); }, sig);
      document.addEventListener('keydown', e => {
        if (e.key !== 'Escape') return;
        const open = this.drops.find(d => d.open);
        if (open) { open.open = false; open.querySelector('summary')?.focus(); }
      }, sig);
      this.addEventListener('change', e => {
        const t = e.target;
        if (t?.name && t.closest('form[is="facet-form"][update-on-change]')) focusNa = {name: t.name, value: t.value};
      }, sig);
      if (focusNa) {
        const doel = [...this.querySelectorAll('input')].find(i => i.name === focusNa.name && i.value === focusNa.value);
        focusNa = null;
        if (doel) requestAnimationFrame(() => doel.focus({preventScroll: true}));
      }

      // 2. Balk volgt de kop
      this.kop = document.querySelector('store-header[hide-on-scroll]');
      if (this.balk && this.anker) {
        let wacht = false;
        const plan = () => { if (!wacht) { wacht = true; requestAnimationFrame(() => { wacht = false; this._volg(); }); } };
        window.addEventListener('scroll', plan, {passive: true, ...sig});
        window.addEventListener('resize', plan, {passive: true, ...sig});
        this._volg();
      }

      // 3. Sheet
      this.sheet = this.querySelector('facet-drawer.banky-facets-sheet');
      if (this.sheet) this._sheet(sig);
    }

    disconnectedCallback() {
      this._ac?.abort();
      this._ac = null;
      this._telAc?.abort();
    }

    _sluitDrops() { this.drops.forEach(d => { d.open = false; }); }

    _plaats(d) {
      const paneel = d.querySelector('.banky-facets__paneel');
      if (!paneel) return;
      paneel.classList.remove('is-rechts');
      const r = paneel.getBoundingClientRect();
      if (r.right > document.documentElement.clientWidth - 16) paneel.classList.add('is-rechts');
    }

    _volg() {
      const top = parseFloat(getComputedStyle(this.balk).top) || 0;
      const vast = this.anker.getBoundingClientRect().top < top - 1;
      let schuif = 0;
      if (vast && this.kop) {
        // Geert 05-10-2026, ronde 4, punt 3: tot en met 1149px zijn aankondigingsbalk en kop één blok (banky-header-float). De balk rust dan
        // onder het hele blok (--sticky-area-height is balk plus kop) en schuift mee met de afstand die de kop van zijn rustplek af is, gemeten
        // aan zijn sectie (height-observer, die schuift niet). Zonder blok (desktop) is die rustplek de kophoogte, zoals eerst.
        const onder = this.kop.getBoundingClientRect().bottom;
        const rust = (this.kop.closest('height-observer') || this.kop.parentElement || this.kop).getBoundingClientRect().bottom;
        const hoogte = Math.max(this.kop.offsetHeight, Math.round(rust));
        schuif = Math.max(-hoogte, Math.min(0, onder - hoogte));
      }
      this.balk.classList.toggle('is-vast', vast);
      this.balk.style.transform = schuif ? `translateY(${schuif}px)` : '';
      // De kop schuift met een CSS-overgang op store-header (Geert 02-10, banky-header-kop.js blok 4: mobiel 300 ms weg en 500 ms terug,
      // desktop 200 en 250 ms): die staat in getAnimations(), dus zolang hij loopt elke frame meebewegen.
      if (this.kop && this.kop.getAnimations && this.kop.getAnimations().length) requestAnimationFrame(() => this._volg());
    }

    _sheet(sig) {
      const form = this.sheet.querySelector('form#facet-form');
      const toon = this.sheet.querySelector('[data-banky-toon]');
      const wis = this.sheet.querySelector('[data-banky-wis]');
      if (!form || !toon) return;
      const tekst = n => {
        const vorm = n === 0 ? toon.dataset.nul : n === 1 ? toon.dataset.een : (toon.dataset.meer || '').replace('[n]', n);
        return (toon.dataset.sjabloon || '[n]').replace('[n]', vorm);
      };
      let klok;
      const tel = () => {
        clearTimeout(klok);
        klok = setTimeout(async () => {
          this._telAc?.abort();
          this._telAc = new AbortController();
          toon.setAttribute('aria-busy', 'true');
          try {
            const html = await (await fetch(bouwUrl(form).toString(), {signal: this._telAc.signal})).text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const n = parseInt(doc.querySelector('[data-banky-aantal]')?.getAttribute('data-banky-aantal'), 10);
            if (!Number.isNaN(n)) { toon.textContent = tekst(n); toon.toggleAttribute('data-leeg', n === 0); }
          } catch (e) { /* netwerkfout of afgebroken: het vorige aantal blijft staan */ }
          toon.removeAttribute('aria-busy');
        }, 300);
      };
      form.addEventListener('change', tel, sig);
      form.addEventListener('input', e => { if (e.target.type === 'number') tel(); }, sig);

      wis?.addEventListener('click', () => {
        form.querySelectorAll('input[type="checkbox"]').forEach(i => { i.checked = false; });
        form.querySelectorAll('price-range').forEach(pr => {
          pr.querySelectorAll('input[type="number"]').forEach(i => { i.value = ''; });
          const [laag, hoog] = pr.querySelectorAll('input[type="range"]');
          if (laag && hoog) {
            laag.value = laag.min; hoog.value = hoog.max;
            laag.parentElement.style.setProperty('--range-min', '0%');
            laag.parentElement.style.setProperty('--range-max', '100%');
          }
        });
        form.dispatchEvent(new Event('change', {bubbles: true}));
      }, sig);

      // Omlaag vegen aan de kop van de sheet sluit hem (zoals een systeemsheet); kort vegen veert terug.
      const greep = this.sheet.querySelector('[data-banky-greep]')?.parentElement;
      const inhoud = () => this.sheet.shadowRoot?.querySelector('[part="content"]');
      if (greep) {
        let y0 = null, dy = 0;
        greep.addEventListener('pointerdown', e => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          y0 = e.clientY; dy = 0;
          greep.setPointerCapture(e.pointerId);
          const c = inhoud(); if (c) c.style.transition = 'none';
        }, sig);
        greep.addEventListener('pointermove', e => {
          if (y0 === null) return;
          dy = Math.max(0, e.clientY - y0);
          const c = inhoud(); if (c) c.style.transform = dy ? `translateY(${dy}px)` : '';
        }, sig);
        const los = () => {
          if (y0 === null) return;
          y0 = null;
          const c = inhoud();
          if (!c) return;
          if (dy > 90) {
            this.sheet.hide();
            this.sheet.addEventListener('dialog:after-hide', () => { c.style.transform = ''; c.style.transition = ''; }, {once: true});
          } else {
            c.style.transition = stil.matches ? 'none' : 'transform .15s ease';
            c.style.transform = '';
          }
        };
        greep.addEventListener('pointerup', los, sig);
        greep.addEventListener('pointercancel', los, sig);
      }
    }
  }

  window.customElements.define('banky-facets', BankyFacets);

  // 5. Sorteren onder 1000px (ronde herstel product-collectie-beeld, 01-10-2026). Halo's popover verhuist zich op de
  //    telefoon en tablet bij openen naar <body> (shouldAppendToBody), waardoor listbox:change van de sorteeroptie niet
  //    meer door <facet-sort-by> bubbelt en Halo's FacetSortBy niets ververst (label wel, volgorde en URL niet). Hier
  //    dezelfde URL als FacetSortBy (sort_by, section_id, zonder page), alleen als het event niet langs facet-sort-by
  //    kwam (composedPath, zodat desktop niet twee keer ververst).
  document.addEventListener('listbox:change', e => {
    const lijst = e.target?.closest?.('x-popover.banky-facets__sortlijst');
    if (!lijst || !e.detail?.value) return;
    if (e.composedPath().some(el => el.tagName === 'FACET-SORT-BY')) return;
    const sectie = lijst.id.replace(/^popover-sort-by-/, '') || document.querySelector('banky-facets[data-banky-sectie]')?.dataset.bankySectie;
    if (!sectie || !document.getElementById('shopify-section-' + sectie)) return;
    const url = new URL(location.href);
    url.searchParams.set('sort_by', e.detail.value);
    url.searchParams.set('section_id', sectie);
    url.searchParams.delete('page');
    document.dispatchEvent(new CustomEvent('facet:update', {bubbles: true, detail: {url}}));
  });
})();
